// 自动生成，请勿手动修改

export const ImgIcons = {
  IconAlipay_1: 'icon_alipay_1.png',
  IconAvatar: 'icon_avatar.png',
  IconBook: 'icon_book.png',
  IconDown: 'icon_down.png',
  IconHelp: 'icon_help.png',
  IconMSearch: 'icon_m_search.png',
  IconNext: 'icon_next.png',
  IconSearch: 'icon_search.png',
  IconSearch2: 'icon_search2.png',
  IconToc: 'icon_toc.png',
  IconWepay_1: 'icon_wepay_1.png',
}